export default coords => {
  if (coords) {
    return {
      lat: coords.latitude,
      lng: coords.longitude
    };
  }
  return null;
};
